import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RadioPicker, RadioOption } from '../../../FlowConfigurationInputs/RadioPicker/RadioPicker';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import { Checkboxes } from '../../../FlowConfigurationInputs';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Paste({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const [tab, setTab] = useState(action.fields.tab?.value ? action.fields.tab.value : 'row');
    const [columnTab, setColumnTab] = useState(action.fields.columnTab?.value ? action.fields.columnTab.value : 'index');
    const [addToLastRow, setAddToLastRow] = useState(false);
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.COPY.';
    useEffect(() => {
        // Assign initial values
        if (!action.fields.tab) {
            action.fields.tab = { value: 'row' };
        }
        if (!action.fields.columnTab) {
            action.fields.columnTab = { value: 'index' };
        }
        if (!action.fields.addToLastRow) {
            action.fields.columnTab = { value: false };
        } else {
            setAddToLastRow(action.fields.addToLastRow.value);
            if (action.fields.tab.value === 'row' && action.fields.addToLastRow.value) {
                delete action.fields.rowNumber;
            }
        }
    }, []);
    // Handle tab change
    const handleClick = (e) => {
        let value = e.target.value;
        action.fields.tab = { value };
        if (value === 'column') {
            delete action.fields.rowNumber;
        }
        if (value === 'cell') {
            delete action.fields.columnName;
            action.fields.valueToAssign = { value: '', type: 'VARIABLEPICKER', isRequired: true };
        }
        setTab(value);
        if (value === 'row') {
            delete action.fields.columnName;
            delete action.fields.columnLetter;
            delete action.fields.columnTab;
        } else {
            action.fields.columnTab = { value: 'index' };
            action.fields.columnLetter = { value: '', htmlValue: '' };
            delete action.fields.columnName;
            setColumnTab('index');
        }
    }
    const handleChange = (e) => {
        let value = e.target.value;
        action.fields.columnTab = { value };
        if (value === 'index') {
            delete action.fields.columnName;
        } else {
            delete action.fields.columnLetter;
        }
        setColumnTab(value);
    }
    const changeAddToLastRow = (e) => {
        if (e.value) {
            delete action.fields.rowNumber
        }
        setAddToLastRow(e.value)
    }
    return (
        <>
            <div className="form-element">
                <div className="form-element">
                    {t(label + 'EXCEL-SOURCE')}
                    <VariablePicker action={action} inputName="excelSource" variables={variables}
                        setOpenVariable={setOpenVariable} filter="data table" isRequired />
                    <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
                </div>
            </div>
            <div className="form-element">
                {t(label + 'ASSIGN-VALUE')}
                <VariablePicker action={action} inputName="valueToAssign" variables={variables}
                    setOpenVariable={setOpenVariable} filter={tab === 'cell' ? 'string' : 'array'}
                    isRequired />
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: tab === 'cell' ? 'string' : 'array' })}</em></small>
            </div>
            <div className="form-element condition-tabs">
                <button className={tab === 'row' ? 'condition-active' : ''} value="row" onClick={handleClick}>
                    {t(label + 'ROW')}
                </button>
                <button className={tab === 'column' ? 'condition-active' : ''} value="column" onClick={handleClick}>
                    {t(label + 'COLUMN')}
                </button>
                <button className={tab === 'cell' ? 'condition-active' : ''} value="cell" onClick={handleClick}>
                    {t(label + 'CELL')}
                </button>
            </div>
            {tab === 'cell' ? <>
                <div className="form-element">
                    {t(label + 'CELL-ROW')}
                    <TextInput action={action} inputName="rowNumber" variables={variables}
                        setOpenVariable={setOpenVariable} isRequired fieldType="string-single-row" displayName={t(label + 'CELL-ROW')} />
                </div>
                <div className="form-element">
                    <RadioPicker value={columnTab} onChange={handleChange}>
                        <RadioOption value="index">
                            {t(label + 'CELL-COLUMN')}
                            <TextInput action={action} inputName="columnLetter" variables={variables}
                                setOpenVariable={setOpenVariable} disabled={columnTab !== 'index'}
                                isRequired={columnTab === 'index'} fieldType="string-single-column" displayName={t(label + 'CELL-COLUMN')} />
                            <em className="form-element-eg">{t(label + 'COLUMN-INDEX-EG')}</em>
                        </RadioOption>
                        <RadioOption value="name" active={columnTab === 'name'}>
                            {t(label + 'COLUMN-NAME')}
                            <TextInput action={action} inputName="columnName" variables={variables}
                                setOpenVariable={setOpenVariable} disabled={columnTab !== 'name'}
                                isRequired={columnTab === 'name'} />
                            <em className="form-element-eg">{t(label + 'COLUMN-NAME-EG')}</em>
                        </RadioOption>
                    </RadioPicker>
                </div>
            </> :
                tab === 'column' ?
                    <div className="form-element">
                        <RadioPicker value={columnTab} onChange={handleChange}>
                            <RadioOption value="index">
                                {t(label + 'CELL-COLUMN')}
                                <TextInput action={action} inputName="columnLetter" variables={variables}
                                    setOpenVariable={setOpenVariable} disabled={columnTab !== 'index'}
                                    isRequired={columnTab === 'index'} fieldType="string-single-column" displayName={t(label + 'CELL-COLUMN')} />
                                <em className="form-element-eg">{t(label + 'COLUMN-INDEX-EG')}</em>
                            </RadioOption>
                            <RadioOption value="name">
                                {t(label + 'COLUMN-NAME')}
                                <TextInput action={action} inputName="columnName" variables={variables}
                                    setOpenVariable={setOpenVariable} disabled={columnTab !== 'name'}
                                    isRequired={columnTab === 'name'} fieldType="string" displayName={t(label + 'COLUMN-NAME')} />
                                <em className="form-element-eg">{t(label + 'COLUMN-NAME-EG')}</em>
                            </RadioOption>
                        </RadioPicker>
                    </div> :
                    <div>
                        <div className="form-element">
                            <Checkboxes action={action} onChange={changeAddToLastRow} inputName="addToLastRow" options={{ label: label + 'ADD-TO-LAST-ROW' }} />
                        </div>
                        {
                            !addToLastRow &&
                            <div className="form-element">
                                {t(label + 'CELL-ROW')}
                                <TextInput action={action} inputName="rowNumber" variables={variables}
                                    setOpenVariable={setOpenVariable} isRequired={!addToLastRow} fieldType='string-single-row' displayName={t(label + 'CELL-ROW')} />
                                <em className="form-element-eg">{t(label + 'ROW-NUMBER-EG')}</em>
                            </div>
                        }
                    </div>
            }
        </>
    );
}

export default Paste;
